const AUTH0_CACHE_KEY_PREFIX = '@@auth0spajs@@';

export function hasAuth0CacheInStorage(): boolean {
  if (typeof window === 'undefined') return false;

  try {
    for (let index = 0; index < localStorage.length; index += 1) {
      const key = localStorage.key(index);
      if (key?.startsWith(AUTH0_CACHE_KEY_PREFIX)) {
        return true;
      }
    }
  } catch {
    return false;
  }

  return false;
}

export async function waitForAuth0Cache(
  maxAttempts = 15,
  delayMs = 200
): Promise<boolean> {
  for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
    if (hasAuth0CacheInStorage()) {
      return true;
    }

    await new Promise((resolve) => {
      window.setTimeout(resolve, delayMs);
    });
  }

  return hasAuth0CacheInStorage();
}

export function isTeamsAuthPopupCancelledError(error: unknown): boolean {
  const message =
    error instanceof Error
      ? error.message
      : typeof error === 'string'
        ? error
        : '';

  return message.includes('CancelledByUser');
}
